import { Context, useContext } from "react";

export function createContextHook<T>(context: Context<T>, hookName: string) {
  return () => {
    const contextValue = useContext(context);
    if (contextValue === undefined) {
      throw new Error(
        `${hookName} must be used within a ${hookName.replace("use", "")}Provider`,
      );
    }
    return contextValue;
  };
}

// Exemplo de uso:
// export const useAccount = createContextHook(AccountContext, 'useAccount');
// export const useChat = createContextHook(ChatContext, 'useChat');
// export const useSidebar = createContextHook(SidebarContext, 'useSidebar');
